import { useState } from "react";
import { Prompteur } from "@features/prompteur/Prompteur";

type Bloc = { type: string; contenu: string };

/** Élément signature : le bouton qui lance le téléprompteur d'appel. */
export function BandeAppel({ prospectId, argumentaire }: { prospectId: string; argumentaire: Bloc[] }) {
  const [ouvert, setOuvert] = useState(false);
  const constat = argumentaire.find(b => b.type === "constat")?.contenu;

  return (
    <section className="callstrip">
      <div>
        <div className="k">Constat d'ouverture</div>
        <div className="c">{constat ?? "Aucun constat rédigé — générer l'argumentaire avant d'appeler."}</div>
      </div>
      <button className="btn" onClick={() => setOuvert(true)} disabled={!constat}>▶ Lancer l'appel</button>
      {ouvert && <Prompteur prospectId={prospectId} blocs={argumentaire} onFermer={() => setOuvert(false)} />}
    </section>
  );
}
